//
// Publishers we hold full-text indexing agreements with. This list is the
// single source of truth for every publisher-count claim in the product —
// the /coverage page renders it in full, and the marketing surfaces quote
// PUBLISHER_COUNT — so adding a partner here updates the copy everywhere.
//
// Treat PUBLISHER_COUNT as a floor, not the total: the list lags the real
// roster between updates, which is why the marketing copy renders it as
// "{PUBLISHER_COUNT}+" rather than an exact figure.
//
export const PUBLISHERS_LAST_UPDATED = 'September 2026'

export const PUBLISHERS = [
  'AboutScience',
  'American Academy of Neurology (published by WKH)',
  'American Association for the Advancement of Science',
  'American Chemical Society',
  'American Medical Association',
  'American Physiological Society',
  'American Psychological Association',
  'American Society for Cell Biology (ASCB)',
  'American Society for Microbiology',
  'Astera',
  'Bentham Science',
  'BioOne',
  'BMJ Publishing Group Ltd.',
  'British Editorial Society of Bone and Joint Surgery',
  'CABI',
  'Cambridge University Press',
  'Emerald Publishing Ltd',
  'Extrica',
  'Galenos Yayinevi Trade Co. Ltd.',
  'IGI Global',
  'Index Copernicus',
  'International Union of Crystallography',
  'IOP Publishing Ltd.',
  'Karger AG',
  'Mark Allen Group',
  'MDPI',
  'Microbiology Society',
  'Noor Al Ilm Publishers',
  'Premier Science',
  'Proceedings of the National Academy of Sciences',
  'Rockefeller University Press',
  'Royal Society of Chemistry',
  'SAGE',
  'SciELO',
  'SLACK',
  'Spandidos Publications',
  'SPIE',
  'Superior University',
  'The Royal Society',
  'Thieme',
  'TransTech',
  'University of Buckingham Press',
  'Wiley',
  'Wolters Kluwer Healthcare'
]

export const PUBLISHER_COUNT = PUBLISHERS.length
